import { Box, Link, Text } from '@approvalmax/ui/src/components';
import React, { memo } from 'react';

import { messages } from '../ProfileSetupForm/ProfileSetupForm.messages';

export const FormSectionFooter = memo(() => {
    return (
        <Box textAlign='center'>
            <Text font='body' fontSize='small' fontWeight='regular' color='midnight70'>
                {messages.signupConsentText({
                    buttonText: messages.signupButtonText,
                    terms: (chunks: any) => (
                        <Link
                            href='https://www.approvalmax.com/terms'
                            target='_blank'
                            rel='noreferrer'
                            font='body'
                            fontSize='small'
                            fontWeight='regular'
                        >
                            {chunks}
                        </Link>
                    ),
                    policy: (chunks: any) => (
                        <Link
                            href='https://www.approvalmax.com/policy'
                            target='_blank'
                            rel='noreferrer'
                            font='body'
                            fontSize='small'
                            fontWeight='regular'
                        >
                            {chunks}
                        </Link>
                    ),
                })}
            </Text>
        </Box>
    );
});

FormSectionFooter.displayName = 'FormSectionFooter';
